import React, { Component, Fragment } from 'react';
import { ErrorMessage, Form, Formik, Field } from 'formik';
import CustomLoader from '../../../common/CustomLoader';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import CustomSelectWithValues from '../../../../common/formElements/CustomSelectWithValues';
import DynamicPageRedirectRule from './DynamicPageRedirectRule';
import { processRediretRule, getFilteredArray } from './util';
import { getFieldInfoByName } from '../collection/Util';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import { FieldTypes } from 'drapcode-constant';
import { builderSurfaceJsonContentHeader } from '../../../../common/utils/restApiHeaderUtils';
import axios from 'axios';

export default class DynamicPageRedirect extends Component {
  state = {
    params: [],
  };

  componentDidMount = () => {
    const { eventAction } = this.props;
    const dbParams = eventAction.parameters.find((param) => param.name === 'redirectRules');
    let params = [];
    if (dbParams && Array.isArray(dbParams.value) && dbParams.value.length > 0) {
      params = [
        ...dbParams.value,
        {
          id: dbParams.value.length + 1,
          fieldValue: '',
          page: '',
          pathField: '',
          seoField: '',
          target: false,
          fieldCollectionSource: 'default',
        },
      ];
    } else {
      params = [
        {
          id: 1,
          fieldValue: '',
          page: '',
          pathField: '',
          seoField: '',
          target: false,
          fieldCollectionSource: 'default',
        },
      ];
    }
    this.setState({ params });
  };

  componentDidUpdate(prevProps, prevState) {
    const { eventAction } = this.props;
    const dbParams = eventAction.parameters || [];
    const savedCollectionNameParam = dbParams.find((p) => p.name === 'collectionName');
    const savedFieldNameParam = dbParams.find((p) => p.name === 'fieldName');
    const savedCollectionName = savedCollectionNameParam ? savedCollectionNameParam.value : '';
    const savedFieldName = savedFieldNameParam ? savedFieldNameParam.value : '';
    if (
      savedCollectionName &&
      savedFieldName &&
      (prevState.collectionName !== savedCollectionName || prevState.fieldName !== savedFieldName)
    ) {
      this.restoreSavedFieldOptions(savedCollectionName, savedFieldName);
    }
  }

  restoreSavedFieldOptions = async (collectionName, fieldName) => {
    const options = await this.setCollectionValuesOptions({ collectionName, fieldName });
    this.setState({
      collectionName,
      fieldName,
      collectionFieldValueOptions: options,
    });
  };

  createNewParamRow = (rowObj) => {
    const params = processRediretRule(this.state.params, rowObj);
    this.setState({ params });
  };

  createActionSettingsSchema = (actionData, eventAction) => {
    let schema = {};
    actionData.args.forEach((args) => {
      const dbParameters = eventAction.parameters.find((param) => {
        return param.name === args.name;
      });
      schema[args.name] = dbParameters
        ? dbParameters.value
        : args.name === 'collectionFrom'
        ? 'collections'
        : '';
    });
    return schema;
  };

  collectionOptions = () => {
    let options = [{ value: '', label: 'Choose Collection' }];
    let collections = this.props.events ? this.props.events.collections : [];
    if (collections.length > 0) {
      options = options.concat(
        collections.map((collection) => {
          return { value: collection.collectionName, label: collection.collectionTitle };
        }),
      );
    }
    return options;
  };

  collectionFieldOptions = (collectionName) => {
    let collections = this.props.events ? this.props.events.collections : [];
    let selectedCollection = collections.find((e) => e.collectionName === collectionName);
    let selectedFields = selectedCollection ? selectedCollection.fields : [];
    selectedFields = selectedFields.filter((e) =>
      ['static_option', 'dynamic_option'].includes(e.type),
    );
    let collectionFieldOptions = [{ value: '', label: 'Choose Field' }];
    if (selectedFields.length > 0) {
      collectionFieldOptions = collectionFieldOptions.concat(
        selectedFields.map((field) => {
          return { value: field.fieldName, label: field.fieldTitle.en };
        }),
      );
    }
    return collectionFieldOptions;
  };

  getPageOptions = () => {
    const { pages } = this.props.events;
    const pageOptions =
      pages.length > 0 ? pages.map((item) => ({ value: item.slug, label: item.name })) : [];
    return pageOptions;
  };

  handlePageChange = (setFieldValue, values, value) => {
    const { pages } = this.props.events;
    const selectedPage = pages.length > 0 ? pages.find((item) => item.slug === value) : null;
    const selectedPagCollection =
      selectedPage && selectedPage.collectionId ? selectedPage.collectionId : '';

    setFieldValue('collectionName', selectedPagCollection);
  };

  handleCollectionChange = (setFieldValue, values, value) => {
    setFieldValue('fieldName', '');
    this.setState({
      collectionName: value,
      fieldName: '',
      params: [
        {
          id: 1,
          fieldValue: '',
          page: '',
          pathField: '',
          seoField: '',
          target: false,
          fieldCollectionSource: 'default',
        },
      ],
      collectionFieldValueOptions: [],
    });
  };

  handleFieldChange = async (name, value) => {
    const { collectionName } = this.state;
    const options = await this.setCollectionValuesOptions({
      collectionName,
      fieldName: value,
      params: [
        {
          id: 1,
          fieldValue: '',
          page: '',
          pathField: '',
          seoField: '',
          target: false,
          fieldCollectionSource: 'default',
        },
      ],
    });
    this.setState({ collectionFieldValueOptions: options, fieldName: value });
  };

  onCollectionFromChange = (setFieldValue, values, value) => {
    if (value === 'session') {
      setFieldValue('collectionName', 'user');
      this.setState({ collectionName: 'user', fieldName: '' });
    } else {
      setFieldValue('collectionName', '');
    }
    setFieldValue('collectionFrom', value);
    setFieldValue('fieldName', '');
    setFieldValue('page', '');
    this.setState({
      fieldCollectionSource: 'default',
      params: [
        {
          id: 1,
          fieldValue: '',
          page: '',
          pathField: '',
          seoField: '',
          target: false,
          fieldCollectionSource: 'default',
        },
      ],
    });
  };

  handleSubmit = (values) => {
    const { actionData, projectId, version, selectedEvent } = this.props;
    const { params } = this.state;
    let parameters = [];
    Object.keys(values).map((value) => {
      const action = actionData.args.find((param) => {
        return param.name === value;
      });
      parameters.push({ name: value, value: values[value], type: action.type });
    });
    parameters.push({
      name: 'redirectRules',
      value: getFilteredArray(params),
      type: 'array',
    });

    let actionFormData = this.props.eventAction;
    actionFormData.parameters = parameters;
    this.props.actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: actionFormData,
    });
    this.props.hideModal();
  };

  getSelectOption = () => {
    let options = [
      { value: 'collections', label: 'Collection binded with Data Group/List/Table' },
      { value: 'collectionForm', label: 'Collection binded with Collection Form' },
      { value: 'page', label: 'Collection binded with Page/Snippet' },
      { value: 'session', label: 'Current Logged In User' },
      {
        value: 'sessionActionResponse',
        label: 'Browser Session',
      },
    ];
    return options;
  };

  getFormForRedirectRules = (values) => {
    const { events } = this.props;
    const { params, collectionFieldValueOptions } = this.state;
    return (
      <div className="col-12">
        <label>
          Redirect Rules{' '}
          {values['collectionFrom'] === 'sessionActionResponse' &&
            `(For default redirection, use keyword DEFAULT or EMPTY in Field Value)`}
        </label>
        <DynamicPageRedirectRule
          createNewParamRow={this.createNewParamRow}
          params={params}
          collectionFrom={values['collectionFrom']}
          selectedCollectionName={values['collectionName']}
          collections={events.collections || []}
          pages={events.pages || []}
          collectionFieldValueOptions={collectionFieldValueOptions}
        />
      </div>
    );
  };

  setCollectionValuesOptions = async (values) => {
    let options = [];
    const { projectId, version, events } = this.props;
    const { collections } = events;
    const selectedCollection = collections.find(
      (e) => e.collectionName === values['collectionName'],
    );
    const selectedCollectionFields = selectedCollection ? selectedCollection.fields : [];
    const selectedField = selectedCollectionFields.find((e) => e.fieldName === values['fieldName']);
    if (!selectedField) {
      return [];
    }
    if (selectedField.type === FieldTypes.static_option.id) {
      selectedField.staticOptions.forEach((e) => options.push({ value: e, label: e }));
    } else if (selectedField.type === FieldTypes.dynamic_option.id) {
      const header = builderSurfaceJsonContentHeader(projectId);
      const { collectionName, collectionField } = selectedField.refCollection;
      await axios
        .get(`${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${collectionName}/`, header)
        .then((res) => {
          if (res.data && res.data.content && Array.isArray(res.data.content)) {
            res.data.content.forEach((item) => {
              if (item[collectionField]) {
                options.push({
                  value: item[collectionField],
                  label: item[collectionField],
                });
              }
            });
          }
        });
    }
    return options;
  };

  render() {
    const { eventAction, actionData } = this.props;
    return (
      <Fragment>
        <Formik
          enableReinitialize={true}
          initialValues={this.createActionSettingsSchema(actionData, eventAction)}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            this.handleSubmit(values);
          }}
        >
          {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
            <Form>
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Data Location"
                      icon="select"
                      infoIcon={true}
                      infoDescription={getFieldInfoByName('dataLocation')}
                    >
                      <CustomSelectWithValues
                        name={'collectionFrom'}
                        isMulti={false}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        options={this.getSelectOption()}
                        value={values['collectionFrom']}
                        formValues={values}
                        setFieldValue={setFieldValue}
                        onChangeOption={this.onCollectionFromChange}
                        placeholder={'Get Data From'}
                      />
                      <ErrorMessage name={'collectionFrom'}>
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </FormFieldWithLabel>
                  </div>
                </div>

                {values['collectionFrom'] === 'page' && (
                  <div className="col-12">
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="Page"
                        icon="select"
                        infoIcon={true}
                        infoDescription={getFieldInfoByName('collectionPage')}
                      >
                        <CustomSelectWithValues
                          name={'page'}
                          isMulti={false}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          options={this.getPageOptions()}
                          value={values['page']}
                          formValues={values}
                          setFieldValue={setFieldValue}
                          onChangeOption={this.handlePageChange}
                        />
                      </FormFieldWithLabel>
                    </div>
                  </div>
                )}

                {values['collectionFrom'] !== 'sessionActionResponse' && (
                  <>
                    <div className="col-12">
                      <div className="form-group">
                        <FormFieldWithLabel
                          cta={false}
                          label="Collection"
                          icon="select"
                          infoIcon={true}
                          infoDescription={getFieldInfoByName('dataLocationCollection')}
                        >
                          <CustomSelectWithValues
                            name={'collectionName'}
                            isMulti={false}
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                            options={this.collectionOptions()}
                            value={values['collectionName']}
                            isDisabled={
                              values['collectionFrom'] === 'page' ||
                              values['collectionFrom'] === 'session'
                            }
                            formValues={values}
                            setFieldValue={setFieldValue}
                            onChangeOption={this.handleCollectionChange}
                          />
                        </FormFieldWithLabel>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <FormFieldWithLabel
                          cta={false}
                          label="Field"
                          icon="select"
                          infoIcon={true}
                          infoDescription={getFieldInfoByName('collectionField')}
                        >
                          <CustomSelect
                            name={'fieldName'}
                            isMulti={false}
                            onChange={setFieldValue}
                            onBlur={setFieldTouched}
                            options={this.collectionFieldOptions(values['collectionName'])}
                            value={values['fieldName']}
                            onChangeValue={this.handleFieldChange}
                          />
                          <ErrorMessage name={'fieldName'}>
                            {(msg) => <p className="text-error">{msg}</p>}
                          </ErrorMessage>
                        </FormFieldWithLabel>
                      </div>
                    </div>
                  </>
                )}

                {values['collectionFrom'] === 'sessionActionResponse' && (
                  <div className="col-12">
                    <div className="form-group">
                      <FormFieldWithLabel
                        cta={false}
                        label="Session Field Name"
                        icon="text"
                        infoIcon={true}
                        infoDescription={getFieldInfoByName('sessionFieldName')}
                      >
                        <Field
                          type={'text'}
                          name={'fieldName'}
                          className="form-control form-control-sm"
                          autoComplete="off"
                          placeholder={'Field Name'}
                        />
                        <ErrorMessage name={'fieldName'}>
                          {(msg) => <p className="text-error">{msg}</p>}
                        </ErrorMessage>
                      </FormFieldWithLabel>
                    </div>
                  </div>
                )}

                {values['fieldName'] &&
                  this.state.collectionFieldValueOptions &&
                  this.getFormForRedirectRules(values)}
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="text-right">
                    <div className="float-left">
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm"
                        onClick={this.props.hideModal}
                      >
                        <span>
                          <i className="wb webconnect-times"></i>&nbsp;Cancel
                        </span>
                      </button>
                    </div>
                    <div className="float-right">
                      <button type="submit" className="btn btn-theme-submit btn-sm">
                        <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                        <CustomLoader loading={this.props.showLoaderForAction} />
                      </button>
                    </div>
                    <div className="clearfix"></div>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Fragment>
    );
  }
}
